import { get12HFormat } from 'modules/core/lib/formatTime'

export const getTimeInUserTimeFormat = (time: string, isTimeFormat12H: boolean): string => {
  return isTimeFormat12H ? (get12HFormat(time) as string) : time
}
